module.exports = __webpack_public_path__ + "static/media/greater-than-equal.767a8657.svg";